import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ConferenceRoom = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="conference-room"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.883 45.242l-7.351-.003c-.943 0-1.831.369-2.499 1.038A3.502 3.502 0 005 48.773l.005 3.377c0 .547.307 1.049.795 1.3A14.103 14.103 0 0012.223 55c2.231 0 4.453-.536 6.425-1.55.487-.251.794-.753.794-1.3l.005-3.374a3.483 3.483 0 00-1.033-2.48 3.605 3.605 0 00-2.531-1.054zM12.222 43.962a5.26 5.26 0 005.254-5.254 5.26 5.26 0 00-5.254-5.254 5.26 5.26 0 00-5.254 5.254 5.26 5.26 0 005.254 5.254zM33.602 45.242l-7.351-.003c-.944 0-1.83.369-2.5 1.038a3.502 3.502 0 00-1.032 2.496l.005 3.377c0 .547.307 1.049.794 1.3A14.104 14.104 0 0029.942 55c2.231 0 4.453-.536 6.425-1.55.487-.251.794-.753.794-1.3l.005-3.374a3.484 3.484 0 00-1.033-2.48 3.604 3.604 0 00-2.53-1.054zM24.687 38.708a5.26 5.26 0 005.254 5.254 5.26 5.26 0 005.254-5.254 5.26 5.26 0 00-5.254-5.254 5.26 5.26 0 00-5.254 5.254zM53.953 46.296a3.605 3.605 0 00-2.532-1.054l-7.351-.003c-.943 0-1.83.369-2.499 1.038a3.502 3.502 0 00-1.032 2.496l.004 3.377c0 .547.307 1.049.795 1.3A14.104 14.104 0 0047.762 55c2.23 0 4.452-.536 6.424-1.55.487-.251.794-.753.795-1.3l.005-3.374a3.485 3.485 0 00-1.033-2.48zM42.506 38.708a5.26 5.26 0 005.254 5.254 5.26 5.26 0 005.255-5.254 5.26 5.26 0 00-5.255-5.254 5.26 5.26 0 00-5.254 5.254zM12.517 9.896h.586v19.72c0 .81.656 1.465 1.465 1.465h30.85c.809 0 1.464-.656 1.464-1.464V9.897h.586a1.464 1.464 0 100-2.93h-16.01v-.503a1.465 1.465 0 00-2.93 0v.503h-16.01a1.464 1.464 0 000 2.93zm6.176 9.541a1.464 1.464 0 012.07-.027l2.59 2.524 7.916-7.717a1.464 1.464 0 012.044 0L37.09 17.9l2.131-2.077a1.464 1.464 0 112.045 2.097l-3.154 3.074a1.464 1.464 0 01-2.044 0l-3.777-3.682-7.916 7.716a1.462 1.462 0 01-2.045 0l-3.61-3.52a1.464 1.464 0 01-.027-2.07z" />
    </svg>
  );
};
/* eslint-enable max-len */

ConferenceRoom.defaultProps = {
  className: null,
};

ConferenceRoom.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ConferenceRoom;
